import React from 'react';

export default function AccountDeletionInstructions() {
  return (
    <div className="mt-2">
      <h1>Delete Your Côntrol Account</h1>
      <p>
        You can delete your Côntrol account at any time. Account deletion will
        completely remove your email, password, name and address from the
        Côntrol servers. Transaction records related to subscriptions may still
        be retained for regulatory compliance.
      </p>
      <p>
        <strong>Warning:</strong> Account deletions are permanent and{' '}
        <strong>CAN NOT</strong> be undone. You will lose access to all vaults
        secured with your account or vaults which you have been given access to
        by other authors.
      </p>
      <h2>Steps to delete your account from the mobile app</h2>
      <ol>
        <li>
          With the Côntrol app opened and your account logged in, tap the user
          icon in the top right of the screen.
        </li>
        <li>
          Tap the trash can icon next to the account you would like to delete.
        </li>
        <li>Choose the &ldquo;Permanently Delete&rdquo; option.</li>
        <li>
          Read the warning that appears and tap &ldquo;Permanently Delete&rdquo;
          again to confirm you want to proceed.
        </li>
      </ol>
      <h2>Steps to delete your account online</h2>
      <ol>
        <li>
          Visit the{' '}
          <a href="https://portal.datarock.biz" target="blank">
            Côntrol Portal
          </a>{' '}
          and log in with your account.
        </li>
        <li>
          Using the navigation menu on the left select <strong>Profile</strong>{' '}
          &gt; <strong>Account</strong>.
        </li>
        <li>
          Near the bottom of the page, click the &ldquo;Remove Account&rdquo;
          link in the account status section.
        </li>
        <li>
          Read the warning that appears then enter the &ldquo;DELETE&rdquo; text
          to confirm you want to continue.
        </li>
      </ol>
    </div>
  );
}
